import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Amplify, { Auth } from 'aws-amplify';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { MsalProvider } from '@azure/msal-react';
import 'react-tooltip/dist/react-tooltip.css';
import { logout, ThemeProvider } from '@qwealth/qcore';
import { QContext } from '@qwealth/qdata';

import { msalInstance } from 'services/microsoft/AuthService';
import store from './data/store';
import App from './App';

import './index.css';
import { errorHandler } from './services/axiosService';

const { REACT_APP_VERSION, REACT_APP_ENV } = process.env;

// eslint-disable-next-line no-console
console.log(`Current app version is: ${REACT_APP_VERSION}`);

QContext.setErrorHandler(errorHandler);

Sentry.init({
  dsn: 'https://5ad671c51b3246d6bb4f5e175b19a0ca@o1168654.ingest.sentry.io/6550426',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: REACT_APP_ENV,
});

const {
  REACT_APP_QWEALTH_AUTH_REGION,
  REACT_APP_QWEALTH_AUTH_USER_POOL_ID,
  REACT_APP_QWEALTH_AUTH_CLIENT_ID,
  REACT_APP_QWEALTH_S3_BUCKET,
  REACT_APP_QWEALTH_IDENTITY_POOL_ID,
} = process.env;

Amplify.configure({
  Auth: {
    identityPoolId: REACT_APP_QWEALTH_IDENTITY_POOL_ID,
    region: REACT_APP_QWEALTH_AUTH_REGION,
    userPoolId: REACT_APP_QWEALTH_AUTH_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_QWEALTH_AUTH_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: REACT_APP_QWEALTH_S3_BUCKET,
      region: REACT_APP_QWEALTH_AUTH_REGION,
    },
  },
});

setTimeout(async () => {
  await logout();
  await Auth.signOut({ global: true });
  alert('Session expired. Please login again.');
}, 7200000);

setTimeout(() => {
  alert('Your session is about to expire. Please save your work.');
}, 6900000);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <MsalProvider instance={msalInstance}>
    <ThemeProvider>
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </ThemeProvider>
  </MsalProvider>,
);
